import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDirectDebetYes({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M5.7 11.5c0 .17 0 .34.02.5H.75a.5.5 0 01-.5-.5v-.55c0-.28.22-.5.5-.5h5.04c-.06.34-.09.7-.09 1.05zM3.48 4.79c.28 0 .5.22.5.5v4.36a.5.5 0 01-.5.5h-.55a.5.5 0 01-.5-.5V5.29c0-.28.22-.5.5-.5h.55zm2.45 4.86V5.29c0-.28.22-.5.5-.5h.55c.28 0 .5.22.5.5v2.03A5.8 5.8 0 005.95 9.8a.44.44 0 01-.02-.15zm4.55-4.86c.28 0 .5.22.5.5v.43c-.54.05-1.06.17-1.55.36v-.79c0-.28.22-.5.5-.5h.55zM6.35.09c.2-.12.45-.12.65 0l5.75 3.13c.61.33.38 1.27-.32 1.27H.93c-.7 0-.94-.94-.33-1.27zm.32 1.35l-3.1 1.7h6.2l-3.1-1.7zM11.5 7a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm1.39 2.99l-1.77 1.77-.91-.9a.65.65 0 10-.92.92l1.37 1.36c.25.26.66.26.92 0l2.23-2.23a.65.65 0 10-.92-.92z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicDirectDebetYes.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDirectDebetYes.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicDirectDebetYes svgRef={ref} {...props} />
));
export default ForwardRef;
